<div class="mct-container">
  <header class="mct-hero">
    <div class="hero-overlay">
      <div class="hero-content">
        <h1 style="color:#C1BFFF;font-weight:700;">About the MCT program</h1>
        <p class="hero-lead">
          The Microsoft Certified Trainer (MCT) Program is Microsoft’s global community of training professionals who
          deliver high-quality, instructor-led learning on Microsoft technologies.
        </p>
        <p class="hero-subtext">
          As an MCT, you gain access to official Microsoft courseware, exclusive resources, and a worldwide network of
          trainers and learning partners. The program is designed to ensure consistent, high-quality training
          experiences while helping individuals and organizations build skills, drive adoption, and stay current with
          Microsoft technologies.
        </p>
      </div>
    </div>
  </header>

  <main class="mct-content-wrapper">
    <div class="mct-layout-grid">

      <section class="details-column">
        <mat-tab-group [selectedIndex]="activeTabIndex" (selectedTabChange)="onTabChange($event)"
          animationDuration="200ms">

          <mat-tab label="Onboarding Experience">
            <ng-template matTabContent>
              <div class="course-info-container">
                <div class="info-column">
                  <div class="tab-body-content">
                    <topaz-capsule class="mct-capsule">Instructor-led + remote
                      course</topaz-capsule>
                    <p class="description-text">
                      The MCT Onboarding Experience is a purpose-built program designed to prepare prospective trainers
                      for success in the MCT role. It equips participants with the core skills, knowledge, and
                      confidence needed to effectively deliver Microsoft training within the global learning ecosystem.
                      Through a structured and engaging experience, participants develop instructional and facilitation
                      skills, gain a clear understanding of MCT program expectations and processes, and build
                      foundational knowledge in AI and modern Microsoft technologies.
                    </p>

                    <div class="course-info-container">
                      <div class="info-column">
                        <h3>This course includes:</h3>
                        <ul class="benefit-list">
                          <li tabindex="0">
                            <mat-icon class="check-icon">check</mat-icon>
                            <span>MCT program orientation</span>
                          </li>
                          <li tabindex="0">
                            <mat-icon class="check-icon">check</mat-icon>
                            <span>Instructional and facilitation skills education</span>
                          </li>
                          <li tabindex="0">
                            <mat-icon class="check-icon">check</mat-icon>
                            <span>Teach-back assessments</span>
                          </li>
                          <li tabindex="0">
                            <mat-icon class="check-icon">check</mat-icon>
                            <span>One-year MCT program fee</span>
                          </li>
                        </ul>
                      </div>

                      <div class="info-column">
                        <h3>Language:</h3>
                        <p class="language-text">
                          This assessment is offered in English, Spanish, Portuguese, German, French, Japanese, and Korean. If you are interested in completing this assessment in any other language, please <a href="mailto:mctprog@microsoft.com"
                            class="email-link">contact us.</a>
                        </p>
                      </div>
                    </div>

                    <div class="prerequisite-section">
                      <h3><strong>Prerequisite:</strong></h3>
                      <p><a
                          href="https://learn.microsoft.com/en-us/credentials/certifications/ai-business-professional/?practice-assessment-type=certification"
                          class="mct-link" target="_blank">AB-730</a> or
                        <a href="https://learn.microsoft.com/en-us/credentials/certifications/ai-transformation-leader/?practice-assessment-type=certification"
                          class="mct-link" target="_blank">AB-731</a> Certification
                      </p>
                      <p>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="calculator-column">
                  <aside style="width:105%" class="calculator-column">
                    <mat-card class="fee-card" appearance="outlined">
                      <mat-card-header>
                        <mat-card-title>Calculate your fee</mat-card-title>
                        <mat-card-subtitle>Price and taxes are based on the country or region in which you are
                          training.</mat-card-subtitle>
                      </mat-card-header>

                      <mat-card-content>
                        <mat-form-field appearance="outline" class="full-width">
                          <mat-label>Country</mat-label>
                          <mat-select [(value)]="selectedCountry" (selectionChange)="fetchCalculatedFee()">
                            @for (country of countries; track country) {
                            <mat-option [value]="country">{{ country }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>

                        <div class="price-display">
                          <span class="currency-amount">{{ amountFee }}</span>
                          <span class="currency-code">{{ currencyFee }}</span>
                        </div>
                        <p class="tax-disclaimer">Taxes calculated at checkout</p>
                      </mat-card-content>
                      <div class="recaptcha-container">
                        <re-captcha #captchaRef="reCaptcha" size="invisible" (resolved)="onCaptchaResolved($event)"
                          [siteKey]="recaptchaSiteKey" (error)="onCaptchaError($event)">
                        </re-captcha>
                      </div>

                      <mat-card-actions class="action-container">

                        <button [disabled]="!score" mat-flat-button class="btn-checkout" (click)="onBuy()">
                          Sign in to buy
                        </button>
                        <p *ngIf="captchaErrorMessage" class="error-text">{{ captchaErrorMessage }}</p>
                      </mat-card-actions>

                      <mat-card-footer class="card-footer-note">
                        <p>We use your Microsoft profile to determine which enrollment you are eligible for. Sign in to
                          see which
                          option suits your needs.</p>
                      </mat-card-footer>
                    </mat-card>
                  </aside>
                </div>
              </div>
            </ng-template>
          </mat-tab>

          <mat-tab label="Instructional Skills Assessment">
            <ng-template matTabContent>
              <div class="course-info-container">
                <div class="info-column">
                  <div class="tab-body-content">
                    <topaz-capsule class="mct-capsule">Self-paced + online
                      exam</topaz-capsule>
                    <p class="description-text">
                      The MCT Instructional Skills Assessment is designed for individuals who have held MCT status in
                      the past or are affiliated with a Higher-Education TSP. This Assessment fast-tracks program entry
                      by validating a participant’s instructional and facilitation skills, as well as MCT program
                      expectations and processes.
                    </p>

                    <div class="course-info-container">
                      <div class="info-column">
                        <h3>You're eligible if:</h3>
                        <ul>
                          <li tabindex="0">
                            <span>You were an active MCT in the last 3 years; or</span>
                          </li>
                          <li tabindex="0">
                            <span>You hold an active Alumni status in the MCT program; or</span>
                          </li>
                          <li tabindex="0">
                            <span>You are affiliated with a Higher-Education TSP</span>
                          </li>
                        </ul>
                      </div>

                      <div class="info-column">
                        <h3>Language:</h3>
                        <p class="language-text">
                            This assessment is offered in 30+ languages.
                        </p>
                      </div>
                    </div>
                    <div class="prerequisite-section">
                      <h3><strong>Prerequisite:</strong></h3>
                      <p><a
                          href="https://learn.microsoft.com/en-us/credentials/certifications/ai-business-professional/?practice-assessment-type=certification"
                          class="mct-link" target="_blank">AB-730</a> or
                        <a href="https://learn.microsoft.com/en-us/credentials/certifications/ai-transformation-leader/?practice-assessment-type=certification"
                          class="mct-link" target="_blank">AB-731</a> Certification
                      </p>
                    </div>
                  </div>
                </div>
                <div class="calculator-column">
                  <aside style="width:105%" class="calculator-column">
                    <mat-card class="fee-card" appearance="outlined">
                      <mat-card-header>
                        <mat-card-title>Calculate your fee</mat-card-title>
                        <mat-card-subtitle>Price and taxes are based on the country or region in which you are
                          training.</mat-card-subtitle>
                      </mat-card-header>

                      <mat-card-content>
                        <mat-form-field appearance="outline" class="full-width">
                          <mat-label>Country</mat-label>
                          <mat-select [(value)]="selectedCountry" (selectionChange)="fetchCalculatedFee()">
                            @for (country of countries; track country) {
                            <mat-option [value]="country">{{ country }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>

                        <div class="price-display">
                          <span class="currency-amount">{{ amountFee }}</span>
                          <span class="currency-code">{{ currencyFee }}</span>
                        </div>
                        <p class="tax-disclaimer">Taxes calculated at checkout</p>
                      </mat-card-content>
                      <div class="recaptcha-container">
                        <re-captcha #captchaRef="reCaptcha" size="invisible" (resolved)="onCaptchaResolved($event)"
                          [siteKey]="recaptchaSiteKey">
                        </re-captcha>
                      </div>

                      <mat-card-actions class="action-container">

                        <button [disabled]="!score" mat-flat-button class="btn-checkout" (click)="onBuy()">
                          Sign in to buy
                        </button>
                        <p *ngIf="captchaErrorMessage" class="error-text">{{ captchaErrorMessage }}</p>
                      </mat-card-actions>

                      <mat-card-footer class="card-footer-note">
                        <p>We use your Microsoft profile to determine which enrollment you are eligible for. Sign in to
                          see which
                          option suits your needs.</p>
                      </mat-card-footer>
                    </mat-card>
                  </aside>
                </div>
              </div>
            </ng-template>
          </mat-tab>

          <mat-tab label="Legacy Instructional Skills Certification">
            <ng-template matTabContent>
              <div class="course-info-container">
                <div class="info-column">
                  <div class="tab-body-content">
                    <p class="description-text">
                      The Instructional Skills Certification Provider (ISCP) program is the predecessor to the MCT
                      Onboarding Experience. Candidates who have successfully completed their ISCP certification may use
                      certificates issued prior to July 1, 2026 to enroll in the MCT program. These certificates will be
                      accepted through December 31, 2026.
                    </p>

                    <div class="prerequisite-section">
                      <h3><strong>Prerequisite:</strong></h3>
                      <p><a
                          href="https://learn.microsoft.com/en-us/credentials/certifications/ai-business-professional/?practice-assessment-type=certification"
                          class="mct-link" target="_blank">AB-730</a> or
                        <a href="https://learn.microsoft.com/en-us/credentials/certifications/ai-transformation-leader/?practice-assessment-type=certification"
                          class="mct-link" target="_blank">AB-731</a> Certification
                      </p>
                    </div>
                  </div>
                </div>
                <div class="calculator-column">

                  <aside style="width:105%" class="calculator-column">
                    <mat-card class="fee-card" appearance="outlined">
                      <mat-card-header>
                        <mat-card-title>Calculate your fee</mat-card-title>
                        <mat-card-subtitle>Price and taxes are based on the country or region in which you are
                          training.</mat-card-subtitle>
                      </mat-card-header>

                      <mat-card-content>
                        <mat-form-field appearance="outline" class="full-width">
                          <mat-label>Country</mat-label>
                          <mat-select [(value)]="selectedCountry" (selectionChange)="fetchCalculatedFee()">
                            @for (country of countries; track country) {
                            <mat-option [value]="country">{{ country }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>

                        <div class="price-display">
                          <span class="currency-amount">{{ amountFee }}</span>
                          <span class="currency-code">{{ currencyFee }}</span>
                        </div>
                        <p class="tax-disclaimer">Taxes calculated at checkout</p>
                      </mat-card-content>
                      <div class="recaptcha-container">
                        <re-captcha #captchaRef="reCaptcha" size="invisible" (resolved)="onCaptchaResolved($event)"
                          [siteKey]="recaptchaSiteKey">
                        </re-captcha>
                      </div>

                      <mat-card-actions class="action-container">

                        <button [disabled]="!score" mat-flat-button class="btn-checkout" (click)="onBuy()">
                          Sign in to buy
                        </button>
                        <p *ngIf="captchaErrorMessage" class="error-text">{{ captchaErrorMessage }}</p>
                      </mat-card-actions>

                      <mat-card-footer class="card-footer-note">
                        <p>We use your Microsoft profile to determine which enrollment you are eligible for. Sign in to
                          see which
                          option suits your needs.</p>
                      </mat-card-footer>
                    </mat-card>
                  </aside>
                </div>
              </div>
            </ng-template></mat-tab>
          <mat-tab label="Microsoft Full-Time Employees">
            <div class="course-info-container">

              <div class="content-column">
                <p class="description-text">
                  Microsoft full-time employees must complete internal coursework in order to attain MCT status. For more information, 
                  please visit <a href="https://aka.ms/MCT4FTE" target="_blank" class="mct-link">aka.ms/MCT4FTE</a>.
                </p>

                <div class="prerequisite-section">
                  <h3><strong>Prerequisite:</strong></h3>
                  <p>
                    <a href="https://learn.microsoft.com/en-us/credentials/certifications/ai-business-professional/?practice-assessment-type=certification"
                      class="mct-link" target="_blank">AB-730</a> or
                    <a href="https://learn.microsoft.com/en-us/credentials/certifications/ai-transformation-leader/?practice-assessment-type=certification"
                      class="mct-link" target="_blank">AB-731</a> Certification
                  </p>
                </div>
              </div>

              <div class="action-column">
                <div class="banner-action-card">
                  <a mat-flat-button href="mailto:mctprog@microsoft.com" class="contact-btn">
                    Contact us
                  </a>
                </div>
              </div>

            </div>
          </mat-tab>
        </mat-tab-group>
      </section>

    </div>
  </main>
</div>